<section class="confirmacao" aria-labelledby="confirmacao-titulo">
  <div class="confirmacao-cartao">
    <h2 class="confirmacao-titulo" id="confirmacao-titulo">{{ saudacao() }}</h2>

    @if (recusada()) {
      <p class="confirmacao-texto">
        Sua manifestação foi registrada sob o protocolo
        <strong class="confirmacao-protocolo">{{ protocolo() }}</strong
        >, mas <strong>não pôde ser aceita</strong> pela Ouvidoria.
      </p>
    } @else {
      <p class="confirmacao-texto">
        Recebemos a sua manifestação, o número do seu protocolo é
        <strong class="confirmacao-protocolo">{{ protocolo() }}</strong>
        para o serviço "Ouvidoria - {{ servico() }}"
      </p>
    }

    @if (aviso()) {
      <p class="confirmacao-aviso" [attr.data-tom]="tomAviso()" role="alert">
        <i-lucide
          [name]="tomAviso() === 'erro' ? 'circle-x' : 'triangle-alert'"
          size="18"
          aria-hidden="true"
        ></i-lucide>
        {{ aviso() }}
      </p>
    }

    @if (redirecionamento()) {
      <p class="confirmacao-aviso" data-tom="info">
        <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
        {{ redirecionamento() }}
      </p>
    }

    <dl class="confirmacao-dados">
      <div class="confirmacao-dado">
        <dt>Situação</dt>
        <dd>{{ abertura()?.situacao }}</dd>
      </div>

      <div class="confirmacao-dado">
        <dt>Abertura</dt>
        <dd>{{ dataAbertura() }}</dd>
      </div>

      @if (!recusada()) {
        <div class="confirmacao-dado">
          <dt>Prazo de resposta</dt>
          <dd>{{ prazoTexto() }} (até {{ dataPrazo() }})</dd>
        </div>
      }

      <div class="confirmacao-dado">
        <dt>Ouvidoria responsável</dt>
        <dd>{{ abertura()?.ouvidoria || 'Ouvidoria do órgão' }}</dd>
      </div>
    </dl>

    <p class="confirmacao-texto">
      Com esse protocolo você pode acompanhar o andamento da sua manifestação por meio dos
      diferentes canais do site: Central Telefônica ou Portal de Atendimento CS - Carta de Serviços.
    </p>

    @if (notificaPorEmail()) {
      <p class="confirmacao-texto">
        Você receberá por e-mail novos comunicados sobre o andamento da sua manifestação.
      </p>
    } @else {
      <p class="confirmacao-texto">
        <strong>Guarde o protocolo</strong>: é por ele que você acompanha esta manifestação — não
        haverá aviso por e-mail.
      </p>
    }

    <p class="confirmacao-texto">Agradecemos o seu contato.</p>
  </div>

  <div class="confirmacao-acoes">
    <button
      type="button"
      class="confirmacao-botao confirmacao-botao-primario"
      (click)="salvarPdf()"
    >
      <i-lucide name="download" size="16" aria-hidden="true"></i-lucide>
      Baixar comprovante
    </button>

    <button type="button" class="confirmacao-botao" (click)="novaManifestacao.emit()">
      <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
      Abrir nova manifestação
    </button>
  </div>
</section>
